// src/app/modules/Members/index.jsx
import React, { Suspense } from "react";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { ManagementMainPage } from "./main";

export function Management() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ManagementMainPage />
    </Suspense>
  );
}